import { Navigate } from 'react-router'
import { Card, Center, Heading, Spinner, Text, VStack } from 'wss3-forge'
import { useAuth } from '../contexts/AuthContext.js'
import { LoginButton } from '../components/LoginButton.js'

export function LoginPage() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <Center style={{ minHeight: '100dvh' }}>
        <Spinner size="lg" />
      </Center>
    )
  }

  if (user) return <Navigate to="/" replace />

  return (
    <Center style={{ minHeight: '100dvh', padding: 'var(--spacing-md)' }}>
      <Card padding="xl" variant="elevated" style={{ width: '100%', maxWidth: 420 }}>
        <VStack gap="lg" align="center">
          <VStack gap="xs" align="center">
            <Heading level={1}>Stark</Heading>
            <Text color="muted" align="center">
              Ton assistant personnel.
            </Text>
          </VStack>
          <LoginButton />
        </VStack>
      </Card>
    </Center>
  )
}
